/**
 * Generated by orval 🍺
 * Do not edit manually.
 * PF Appointments API
 * appointments-api v1. Generated from the route table; do not edit by hand (pnpm openapi).
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod'

export const appointmentDayCountsItemsItemCountMax = 9007199254740991

export const appointmentDayCountsItemsItemDateRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$')
export const appointmentDayCountsItemsItemLocationIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)

export const AppointmentDayCounts = zod.object({
  items: zod.array(
    zod.object({
      count: zod.int().min(1).max(appointmentDayCountsItemsItemCountMax),
      date: zod.string().regex(appointmentDayCountsItemsItemDateRegExp),
      locationId: zod.uuid().regex(appointmentDayCountsItemsItemLocationIdRegExp),
    }),
  ),
})

export type AppointmentDayCounts = zod.input<typeof AppointmentDayCounts>
export type AppointmentDayCountsOutput = zod.output<typeof AppointmentDayCounts>
